import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { Auth } from "aws-amplify";
import { useAuthenticator } from "@aws-amplify/ui-react";
import { redirect } from "../../services/redirect";
import { updateUserInfoAcknowledgement } from "../../services/UserInfoService";
import "./TermsAndConditions.css";
import { setCookie } from "../../services/cookies";

export const TermsAndConditions = () => {
    const { t } = useTranslation("locale");
    const { user } = useAuthenticator((context) => [context.user]);
    const { state: redirectParam } = useLocation();

    const onClickTerms = () => window.open("https://www.idwalmarine.com/terms-and-conditions/terms-of-use", '_blank', 'noopener,noreferrer');

    const onClickAgree = async () => {
        const poolIdName = process.env.REACT_APP_AUTH_USER_POOL_ID?.split("_")[1];
        const cookieName = `idwal-${poolIdName}-acknowledgement`;

        await setCookie(cookieName, true, 12);
        await updateUserInfoAcknowledgement(user?.username);

        if (user?.attributes?.email_verified) {
            redirect(user, redirectParam);
        }
    };

    const onClickDisagree = () => {
        Auth.signOut().then(() => {
            redirect(user, redirectParam);
        });
    }

    return (
        <div className="terms-and-conditions-container">
            <h3 className="terms-and-conditions-header">
                {t("termsAndConditions.header_label")}
            </h3>
            <span className="terms-and-conditions-info">
                {`${t("termsAndConditions.info_label")} `}
                <a className="terms-and-conditions-info-link" onClick={onClickTerms}>
                    {`${t("termsAndConditions.link_label")}.`}
                </a>
            </span>
            <button className="terms-and-conditions-agree-button" onClick={onClickAgree}>
                {t("termsAndConditions.agree_label")}
            </button>
            <div className="terms-and-conditions-disagree-container">
                <a className="terms-and-conditions-disagree-link" onClick={onClickDisagree}>
                    {t("termsAndConditions.disagree_label")}
                </a>
            </div>
        </div>
    );
};
